import React from 'react';
import { Col, Row } from 'antd';
import TestExecutionListViewItem from './TestExecutionListViewItem';
import Loading from '../../../components/Loading';
import ClientSidePagination from '../../../components/Pagination/ClientSidePagination';

interface propType {
  testSuites: any[]
  handleRefresh: Function
  isLoading: boolean
  openEDSModal: Function
  currentPage: number
  pageSize: number
  total: number
  onPaginationChange: (page: number, pageSize: number) => void
}

const TestExecutionListView = ({
  testSuites,
  handleRefresh,
  isLoading,
  openEDSModal,
  currentPage,
  pageSize,
  total,
  onPaginationChange,
}: propType) => (
  <div className="fp_list">
    <Row justify="space-between" className="fp_list_title">
      <Col span={10}><p>Test suite name</p></Col>
      <Col span={4}><p>Last run</p></Col>
      <Col span={3}><p>Overall result</p></Col>
      <Col span={4}><p> </p></Col>
    </Row>
    {isLoading ? <Loading plain size="large" /> : testSuites.map((testSuite: any) => (
      <TestExecutionListViewItem
        key={testSuite?.testSuiteId}
        testSuite={testSuite}
        handleRefresh={handleRefresh}
        openEDSModal={openEDSModal}
      />
    ))}
    {!isLoading && (
      <ClientSidePagination
        currentPage={currentPage}
        total={total}
        pageSize={pageSize}
        onPaginationChange={onPaginationChange}
      />
    )}
  </div>
);

export default TestExecutionListView;
